import(/* webpackMode: "eager" */ "/app/src/app/not-found.tsx")